<template lang="pug">
  .height-100
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalAdjuntar"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
        upload-multi-file(
          name="adjuntar_boletas_manuales",
          folder="boletas-manuales",
          @save="guardarAdjuntos",
          @close="closeModalAdjuntar"
        )
          span(slot="title") Adjunte los pdf de las boletas
          span(slot="explanation") Recuerda que los archivos deben tener el DNI al inicio del nombre del archivo

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEliminarTodo"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionEliminarTodo = false"
        @do="eliminarTodasLasBoletasManuales"
      )
        span(slot="title") ¿Desea eliminar todas las boletas cargadas?
        span(slot="primaryAction")
          span(v-if="isProcessing") Eliminando...
          span(v-else) Eliminar todo
        strong Solo se eliminaran las boletas de la carga manual actual, no las generadas

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionGenerarBoletas"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionGenerarBoletas = false"
        @do="generarBoletasManuales"
      )
        span(slot="title") ¿Desea generar las boletas cargadas?
        span(slot="primaryAction")
          span(v-if="isProcessing") Generando...
          span(v-else) Generar
        strong No cierre la pestaña del navegador mientras se están generando las boletas
        transition(name="fade")
          p.margin-top-10.margin-bottom-10(v-show="isProcessing")
            span.big {{ (cantidadAvance / cantidadTotal * 100).toFixed(2) }}%
            span.small.ml-5 {{ cantidadAvance }} / {{ cantidadTotal }}

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Carga manual de boletas

        .message.is-info
          .message-body
            ul
                li Solo se pueden trabajar simultaneamente, boletas de un mismo periodo, mes y tipo
                li Los archivos pdf deben tener el DNI al inicio, seguido de un "_", para obtener el empleado automáticamente, sino se deberá hacer la asignación manualmente.

        .display-flex.ai-c.filtros-completos
          .display-flex.flex-1.filtro-input
            .flex-1.px-20
              .control.title-singular
                p Periodo
                .input-container
                  input.input(
                    type="number",
                    v-model="periodo"
                  )
            .flex-1.px-20
              .control.title-singular
                p Mes
                .input-container
                  input.input(
                    type="number",
                    v-model="mes"
                  )
            .flex-1.px-20
              .control.title-singular
                p Tipo
                .select
                  select(v-model='tipo')
                    option(value="all") Todos
                    option(:value="o.codigo", v-for="o in tipos") {{o.descripcion}}

          .text-right.media-pt-10
            button.button.is-small.margin-right-5.is-primary(@click="openModalAdjuntar")
              span.icon.is-small
                i.fa.fa-upload.fs-12
              span Adjuntar
            button.button.is-small(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar

        div.mt-20
          .text-right
            button.button.is-small.margin-right-5.is-primary(
              @click="mostrarConfirmacionGenerarBoletas = true"
              :disabled="lista.length === 0 || isLoading"
              )
              span.icon.is-small
                i.fa.fa-bolt.fa-fw.fa-lg
              span Generar boletas
            button.button.is-small.is-danger.ml-5(@click="mostrarConfirmacionEliminarTodo = true")
              span.icon.is-small
                i.fa.fa-times.fa-fw.fa-lg
              span Eliminar todo

        transition(name="fade")
          p.margin-top-10.margin-bottom-10(v-show="isVerifying")
            span.big {{ (cantidadAvance / cantidadTotal * 100).toFixed(2) }}%
            span.small.ml-5 {{ cantidadAvance }} / {{ cantidadTotal }}

        .body
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .information(v-else)
            template(v-if="lista.length !== 0")
              .is-desktop
                table.table.is-striped.is-bordered
                  thead
                    th Empleado
                    th.hide-break-1 DNI obtenido
                    th Nombre de archivo
                    th.hide-break-1 Fecha de modificación
                    th Acciones
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                      :class="{'is-close': !o.codigo}"
                    )
                      //- td {{ o.id }}
                      td
                        template(v-if="o.codigo")
                          .show-break-1
                            strong DNI:&nbsp;
                            span {{ o.dniObtenido }}
                          .display-flex.hint--bottom(:aria-label="'Empleado: '+ o.codigo")
                            span.name {{ o.nombre }}
                            .cursor-pointer.ml-5(title="Desasignar empleado")
                              i.fa.fa-times(
                                @click="desasignarEmpleadoABoletaManual(o)"
                              )
                        template(v-else)
                          div.position-relative
                            .control.display-flex.align-items-center
                              input.input(
                                type="number",
                                v-model="o.codigoEmpleadoReemplazante"
                              )
                              span.icon.cursor-pointer.margin-left-5(@click="o.mostrarBusquedaEmpleado = true")
                                i.fa.fa-search
                            transition(name="fade-quick")
                              .pop-over(
                                  v-if="o.mostrarBusquedaEmpleado"
                                )
                                  lookup-small-empleado(
                                    @selected="asignarEmpleadoABoletaManual(o, $event)"
                                    @close="o.mostrarBusquedaEmpleado = false"
                                    :codigo="o.codigoEmpleadoReemplazante"
                                  )
                      td.hide-break-1 {{ o.dniObtenido }}
                      td
                        div {{ o.namefile }}
                        .show-break-1.mt-10
                          strong Modificado:&nbsp;
                          span {{ o.modificado }}
                      td.hide-break-1 {{ o.modificado }}
                      td.text-center
                        template(v-if="o.ruta")
                          a.button.is-small(:href="o.ruta", target="_blank")
                            span.icon.is-small
                              i.fa.fa-paperclip.is-small.fs-12
                            span Ver adjunto
                        template(v-else)
                          span.no-accion Sin adjunto
                        .contenedor-acciones
                          button.button.is-small.is-danger.ml-5(@click="eliminar(o.id, o)" :class="{'is-loading': o.isRemoving}")
                            span.icon.is-small
                              i.fa.fa-times
                            span Eliminar
              .is-mobile
                loading(v-if="isLoading")
                .box(
                  v-for="(o, index) in lista"
                  :key="index"
                  :class="{'bg-red': !o.codigo}"
                )
                  template(v-if="o.codigo")
                    div
                      strong DNI:&nbsp;
                      span {{ o.dniObtenido }}
                    .descripcion-tipo.display-flex
                      span.hint--top(:aria-label="'Empleado: ' + o.id") {{ o.nombre }}
                      .cursor-pointer.ml-5(title="Desasignar empleado")
                        i.fa.fa-times(
                          @click="desasignarEmpleadoABoletaManual(o)"
                        )
                  template(v-else)
                    .mb-10
                      .position-relative
                        .control.display-flex.align-items-center
                          input.input(
                            type="number",
                            v-model="o.codigoEmpleadoReemplazante"
                          )
                          span.icon.cursor-pointer.margin-left-5(@click="o.mostrarBusquedaEmpleado = true")
                            i.fa.fa-search
                        transition(name="fade-quick")
                          .pop-over(
                              v-if="o.mostrarBusquedaEmpleado"
                            )
                              lookup-small-empleado(
                                @selected="asignarEmpleadoABoletaManual(o, $event)"
                                @close="o.mostrarBusquedaEmpleado = false"
                                :codigo="o.codigoEmpleadoReemplazante"
                              )
                  .motivo
                    span {{ o.namefile }}
                  .dias-pedidos.mt-5
                    strong Fecha de modificación:&nbsp;
                    div {{ o.modificado }}
                  .botones
                    template(v-if="o.ruta")
                      a.button.is-small(:href="o.ruta", target="_blank")
                        span.icon.is-small
                          i.fa.fa-paperclip.is-small.fs-12
                        span Ver adjunto
                    template(v-else)
                      span.no-accion Sin adjunto
                    button.button.is-small.is-danger.ml-5(@click="eliminar(o.id, o)" :class="{'is-loading': o.isRemoving}")
                      span.icon.is-small
                        i.fa.fa-times
                      span Eliminar

            div(v-else)
              .message.is-warning
                .message-body No hay documentos importantes ingresados
</template>

<script>
import UploadMultiFileComponent from '../components/c_upload_multi_files'
import LookupSmallEmpleado from '../components/Component_Lookup_Small_Empleado.vue'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
// import VueCircle from 'vue2-circle-progress'
import Spinner from 'vue-simple-spinner'
export default {
  name: 'boletas-carga-manual',
  data () {
    return {
      lista                             : [],
      isLoading                         : false,
      mostrarModalAdjuntar              : false,
      idSeleccionado                    : null,
      cantidadAvance                    : 0,
      cantidadTotal                     : 0,
      filesAdjuntos                     : [],
      isVerifying                       : false,
      mostrarConfirmacionEliminarTodo   : false,
      mostrarConfirmacionGenerarBoletas : false,
      periodo                           : '',
      mes                               : '',
      tipo                              : '',
      descripcionTipo                   : '',
      isProcessing                      : false,
      tipos                             : []
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  components: {
    'upload-multi-file': UploadMultiFileComponent,
    Spinner,
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  mounted () {
    this.fetch()
    this.fetchTipos()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true

      var obj = {
      }

      apiGet(vm, '/boleta/manual/archivos/temporal', obj, function (data) {
        for (let i = 0; i < data.lista.length; i++) {
          data.lista[i].isRemoving = false
        }
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    recursivoGuardarAdjunto (index, callback) {
      var vm = this
      var obj = {
        file: vm.filesAdjuntos[index]
      }

      apiPost(vm, '/boleta/manual/archivos/temporal', obj, function (data) {
        if (data.status === 2) {
          notify(vm, 'warning', 'Advertencia', data.message)
        }

        index++
        vm.cantidadAvance = index
        if (index === vm.filesAdjuntos.length) callback(null)
        else vm.recursivoGuardarAdjunto(index, callback)
      }, function (error) {
        callback(error)
      }, function () {

      })
    },
    guardarAdjuntos (files) {
      var vm = this

      vm.filesAdjuntos = []
      for (var i = 0; i < files.length; i++) {
        vm.filesAdjuntos.push(files[i])
      }

      vm.cantidadTotal = vm.filesAdjuntos.length

      vm.closeModalAdjuntar()
      // Enviar metodo recursivo para ir al server, buscar empleado e insertar en la tabla temporal
      vm.isVerifying = true
      vm.recursivoGuardarAdjunto(0, function (err) {
        vm.isVerifying = false
        if (err) {
          notify(vm, 'error', 'Error', err.message)
          return
        }

        notify(vm, 'success', 'Exito', 'Verificados correctamente')
        vm.fetch()
      })
    },
    eliminar (id, o) {
      var vm = this
      if (o.isRemoving) return

      o.isRemoving = true

      var obj = {
        id: id
      }

      apiDelete(vm, '/boleta/manual/archivos/temporal', obj, function (data) {
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        o.isRemoving = false
      })
    },
    asignarEmpleadoABoletaManual (o, empleado) {
      o.codigoEmpleadoReemplazante = empleado.codigo
      var vm = this
      var obj = {
        id     : o.id,
        codigo : empleado.codigo,
        nombre : empleado.nombre
      }
      apiPost(vm, '/boleta/manual/archivos/empleado/asignar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se asigno el empleado de reemplazo correctamente')
        o.codigo      = empleado.codigo
        o.nombre      = empleado.nombre
        o.dniObtenido = empleado.dni
        o.codigoEmpleadoReemplazante = ''
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    desasignarEmpleadoABoletaManual (o) {
      var vm = this
      var obj = {
        id     : o.id
      }
      apiPost(vm, '/boleta/manual/archivos/empleado/desasignar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se desasigno el empleado correctamente')
        o.codigo      = ''
        o.nombre      = ''
        o.dniObtenido = ''
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    eliminarTodasLasBoletasManuales (o) {
      var vm = this

      if (!vm.isProcessing) {
        vm.isProcessing = true
        var obj = {
        }
        apiDelete(vm, '/boleta/manual/archivos/temporal/todo', obj, function (data) {
          notify(vm, 'success', 'Éxito', 'Se eliminaron todas las boletas de la carga manual')
          vm.isProcessing = false
          vm.mostrarConfirmacionEliminarTodo = false
          vm.fetch()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
          vm.isProcessing = false
          vm.mostrarConfirmacionEliminarTodo = false
        })
      }
    },
    generarBoletaRecursivo (callback) {
      var vm = this

      var obj = {
        periodo         : vm.periodo,
        mes             : vm.mes,
        tipo            : vm.tipo,
        descripcionTipo : vm.descripcionTipo,
        cantidadAvance  : vm.cantidadAvance
      }
      apiPost(vm, '/boleta/manual/generar', obj, function (data) {
        vm.cantidadAvance++
        if (data.noMore) {
          // Ya no hay mas que generar
          callback(null, null)
        } else {
          // Aun hay boletas que generar
          vm.generarBoletaRecursivo(callback)
        }
      }, function (error) {
        callback(error)
      })
    },
    generarBoletasManuales () {
      var vm = this

      if (!vm.isProcessing) {
        vm.isProcessing = true
        var obj = {
          periodo : vm.periodo,
          mes     : vm.mes,
          tipo    : vm.tipo
        }
        apiGet(vm, '/boleta/manual/generar/verificar', obj, function (data) {
          // Si entra aca es porque todo esta oka, empecemos a generar
          // Debe retornar tambien la cantidad total de documentos para mostrarlo como total
          vm.cantidadAvance  = 0
          vm.cantidadTotal   = data.cantidadTotal
          vm.descripcionTipo = data.descripcionTipo
          vm.generarBoletaRecursivo(function (err, data) {
            if (err) {
              console.error('Error')
              notify(vm, 'error', 'Error', err.message)
              vm.isProcessing = false
              return
            }
            notify(vm, 'success', 'Exito', 'Se generaron las boletas')
            vm.mostrarConfirmacionGenerarBoletas = false
            vm.fetch()
            vm.isProcessing = false
          })
        }, function (error) {
          vm.isProcessing = false
          vm.mostrarConfirmacionGenerarBoletas = false
          notify(vm, 'error', 'Error', error.message)
        })
      }
    },
    fetchTipos () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/boleta/tipos', obj, function (data) {
        vm.tipos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fs-12
    font-size 12px  !important
  .bg-red
    background-color:#ffd6d6
  .botones
    display flex
    justify-content center
    margin-top 10px
    .button
      margin-right 5px
      &:last-child
        margin-right 0px
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px
  .button.is-loading
    margin-top 0px


  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .contenedor-acciones
    padding-top 4px
    display flex
    .button
      flex 1
      margin 0px 5px
  td.text-center
    span.no-accion
      font-size: 12px
  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde

  .small
    font-size: 12px;
    color: #9a9a9a;

  .big
    font-size: 28px;
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);

  .show-break-1
    display none

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
      justify-content center
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      width: 100%;
      padding-top: 5px;
      padding-bottom: 5px;
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media (max-width: 900px)
    .show-break-1
      display initial

    .hide-break-1
      display none


  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 608px)
    .is-desktop
      display none

    .is-mobile
      display block

    .filtro-input
      flex-direction column
  @media (max-width: 500px)
    .filtros-completos
      flex-direction column

  @media (max-width: 450px)
    .media-pt-10
      padding-top 10px

</style>




// WEBPACK FOOTER //
// View_Boletas_Carga_Manual.vue?5700f6d1